var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Error Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error-Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Alerts-/-Soft-Warning-Inline",
    fill: "#AA0000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,2 C14.6521649,2 17.195704,3.0535684 19.0710678,4.92893219 C20.9464316,6.80429597 22,9.3478351 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M12,3.66666667 C7.39762708,3.66666667 3.66666667,7.39762708 3.66666667,12 C3.66666667,16.6023729 7.39762708,20.3333333 12,20.3333333 C16.6023729,20.3333333 20.3333333,16.6023729 20.3333333,12 C20.3333333,7.39762708 16.6023729,3.66666667 12,3.66666667 Z M11.8083333,13.65 C12.0497693,13.6427322 12.2839933,13.7328184 12.4583333,13.9 C12.6267439,14.0604868 12.7204045,14.2840637 12.7166667,14.5166667 C12.7245024,14.7476228 12.6299603,14.9702541 12.4583333,15.125 C12.2812033,15.286798 12.0481408,15.3734494 11.8083333,15.3666667 C11.5707833,15.3748554 11.3397958,15.2878601 11.1666667,15.125 C11.0034533,14.9650744 10.9130709,14.745144 10.9166667,14.5166667 C10.9107566,14.2853145 11.0013203,14.0619239 11.1666667,13.9 C11.33451,13.7280543 11.5684046,13.6369265 11.8083333,13.65 Z M12.55,8.075 L12.4,12.8916667 L11.2666667,12.8916667 L11.1666667,8.075 L12.55,8.075 Z",
    id: "Icon"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.719ef59361cd8f68f1ca1990d2f378c1.svg";
export { ForwardRef as ReactComponent };